<template>
  <a
    v-if="link.length > 0"
    :href="link"
    class="btn btn-white"
  >
    <slot>
      {{ label }}
    </slot>
  </a>
  <button
    v-else
    class="btn btn-white"
  >
    <slot>
      {{ label }}
    </slot>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    label: {
      type: String,
      required: true
    },
    link: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang='scss' scoped>
.btn {
  width: 100%;
  margin: 7px 0;
}
</style>
